import { render, staticRenderFns } from "./ResourceOverview.vue?vue&type=template&id=b28d43b2&scoped=true&"
import script from "./ResourceOverview.vue?vue&type=script&lang=js&"
export * from "./ResourceOverview.vue?vue&type=script&lang=js&"
import style0 from "./ResourceOverview.vue?vue&type=style&index=0&id=b28d43b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28d43b2",
  null
  
)

export default component.exports